// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoryTitleSection_container___qIkZ"};